<template>
    <div>
        <div>
            <table class="ix-table ix-table-no-borders">
                <tbody>
                    <tr>
                        <td colspan="2" class="ix-text-bold">TVA</td>
                    </tr>
                    <tr v-for="(vat, index) in vats" v-bind:key="index">
                        <td style="width: 150px;">
                            <div class="input-group input-group-sm">
                                <input type="number" step="0.01" class="form-control text-center" required min="0" v-model="vat.rate" :name="'vats[' + index + '][rate]'">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="input-group input-group-sm">
                                <input type="number" step="0.01" class="form-control text-right" required min="0" v-model="vat.amount" :name="'vats[' + index + '][amount]'">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                    <button class="ix-btn ix-btn-sm icon" type="button" @click="deleteRow(index)" v-if="vats.length > 1">
                                        <i class="far fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <button @click="addRow(null)" type="button" class="ix-btn link"><i class="far fa-plus"></i> Ajouter une TVA</button>
                        </td>
                    </tr>
                    <tr>
                        <td class="ix-text-bold">Total TVA</td>
                        <td class="text-right">
                            {{ currency(total_vat) }}
                            <input type="hidden" v-model="total_vat" name="total_vat">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        
    </div>
</template>

<script>
    export default {
        name: 'vats-array',
        props: ['oldVats'],
        data() {
            return {
                vats: [],
            };
        },
        computed: {
            total_vat: function() {
                var sum = 0;
                this.vats.forEach(vat => sum += parseFloat(vat.amount));
                return sum;
            },
        },
        methods : {
            addRow: function(vat) {
                this.vats.push({
                    'rate': vat != null ? vat.rate : (this.vats.length == 0 ? 20 : ''),
                    'amount': vat != null ? vat.amount : 0
                })
            },
            deleteRow: function (index) {
                this.vats.splice(index, 1)
                if (this.vats.length == 0) {
                    this.addRow(null)
                }
            },
        },
        mounted() {
            const jsonVatsBackup = JSON.parse(this.oldVats)
            if (Array.isArray(jsonVatsBackup)) {
                if (jsonVatsBackup.length > 0) {
                    jsonVatsBackup.forEach(vat => {
                        this.addRow(vat)
                    })
                }
            }

            /*if (this.oldVats == undefined || this.oldVats.length == 0) {
                this.addRow(null)
            }*/

            console.log(this.oldVats)
        }
    }
</script>
